import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userResetUnseenChatMessages } from '../../app-communication/actions/from-client-frontend';
import { useIntl } from 'react-intl';

const useDynamicTitle = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const unseenMsgCount = useSelector((store) => store.operators.unseenMsgCount);

  React.useEffect(() => {
    const originalTitle = document.title;

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        dispatch(userResetUnseenChatMessages());
        document.title = originalTitle;
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let intervalId;

    const alternateTitle = () => {
      document.title =
        document.title === intl.formatMessage({ id: 'translate.page.title.new.messages' })
          ? intl.formatMessage({ id: 'translate.page.title.unseen.messages' }, { count: unseenMsgCount })
          : intl.formatMessage({ id: 'translate.page.title.new.messages' });
    };

    if (document.visibilityState === 'hidden' && unseenMsgCount) {
      document.title = intl.formatMessage({ id: 'translate.page.title.new.messages' });
      intervalId = setInterval(alternateTitle, 5000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [unseenMsgCount, intl]);
};

export default useDynamicTitle;
